import axios from 'axios'
export default class CrmConnectionCheck {
    constructor(el) {
        if (el.dataset.crmConnectionCheck) {
            el.addEventListener('click', function () {
                axios({
                    method: 'get',
                    url: '/api/crm/connection',
                })
                    .then((response) => {
                        if (response.data && !response.data.isAlive) {
                            window.location.replace(response.data.redirectUrl)
                        }
                    })
                    .catch((err) => {
                        console.error('crm-connection-check.js error:', err)
                    })
            })
        }
    }
}
